<mat-tab-group mat-align-tabs="center">
    <mat-tab label="About Me">Content 1</mat-tab>
    <mat-tab label="Technical Skills">Content 2</mat-tab>
    <mat-tab label="Work Experience">Content 3</mat-tab>
    <mat-tab label="Contact">Content 3</mat-tab>
  </mat-tab-group>

  <div>
    <span>About Me</span>
    <span>Technical Skills</span>
    <span>Work experience</span>
    <span>Contact</span>
  </div>
